/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * @summary 프로모션 코드 생성
 */
export const adminPromotionControllerCreateBodyMaxUsesPerUserDefault = 1;

export const adminPromotionControllerCreateBody = zod
  .object({
    code: zod.string().describe("Promotion Code (e.g. SEMO_LAUNCH_2026)"),
    description: zod.string().describe("Description"),
    targetPlanType: zod
      .enum(["FREE", "PRO", "ENTERPRISE", "TEST"])
      .describe("Target Plan"),
    durationDays: zod.number().describe("Duration in days"),
    maxUsesPerCode: zod
      .number()
      .optional()
      .describe("Max uses total (null for infinite)"),
    maxUsesPerUser: zod.number().describe("Max uses per user"),
    validFrom: zod.string().optional().describe("Valid from date"),
    validUntil: zod.string().optional().describe("Valid until date"),
  })
  .strict();

/**
 * @summary 프로모션 코드 목록 조회
 */
export const adminPromotionControllerFindAllQueryParams = zod
  .object({
    offset: zod.coerce.number().optional(),
    limit: zod.coerce.number().optional(),
  })
  .strict();

export const adminPromotionControllerFindAllResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("Promotion ID"),
              code: zod.string().describe("Promotion Code"),
              description: zod.string().optional().describe("Description"),
              targetPlanType: zod
                .enum(["FREE", "PRO", "ENTERPRISE", "TEST"])
                .describe("Target Plan Type"),
              durationDays: zod.number().describe("Duration in days"),
              maxUsesPerCode: zod
                .number()
                .optional()
                .describe("Max uses total"),
              currentUses: zod.number().describe("Current usage count"),
              maxUsesPerUser: zod.number().describe("Max uses per user"),
              validFrom: zod
                .string()
                .datetime({})
                .optional()
                .describe("Valid from date"),
              validUntil: zod
                .string()
                .datetime({})
                .optional()
                .describe("Valid until date"),
              isActive: zod.boolean().describe("Is Active status"),
              createdAt: zod.string().datetime({}).describe("Created At"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 프로모션 코드 상세 조회
 */
export const adminPromotionControllerFindOneParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminPromotionControllerFindOneResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("Promotion ID"),
        code: zod.string().describe("Promotion Code"),
        description: zod.string().optional().describe("Description"),
        targetPlanType: zod
          .enum(["FREE", "PRO", "ENTERPRISE", "TEST"])
          .describe("Target Plan Type"),
        durationDays: zod.number().describe("Duration in days"),
        maxUsesPerCode: zod.number().optional().describe("Max uses total"),
        currentUses: zod.number().describe("Current usage count"),
        maxUsesPerUser: zod.number().describe("Max uses per user"),
        validFrom: zod
          .string()
          .datetime({})
          .optional()
          .describe("Valid from date"),
        validUntil: zod
          .string()
          .datetime({})
          .optional()
          .describe("Valid until date"),
        isActive: zod.boolean().describe("Is Active status"),
        createdAt: zod.string().datetime({}).describe("Created At"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 프로모션 코드 수정
 */
export const adminPromotionControllerUpdateParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminPromotionControllerUpdateBody = zod
  .object({
    isActive: zod.boolean().optional().describe("Is Active"),
    maxUsesPerCode: zod
      .number()
      .optional()
      .describe("Increase max uses (add to current)"),
    validUntil: zod.string().optional().describe("Valid until date"),
  })
  .strict();

export const adminPromotionControllerUpdateResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("Promotion ID"),
        code: zod.string().describe("Promotion Code"),
        description: zod.string().optional().describe("Description"),
        targetPlanType: zod
          .enum(["FREE", "PRO", "ENTERPRISE", "TEST"])
          .describe("Target Plan Type"),
        durationDays: zod.number().describe("Duration in days"),
        maxUsesPerCode: zod.number().optional().describe("Max uses total"),
        currentUses: zod.number().describe("Current usage count"),
        maxUsesPerUser: zod.number().describe("Max uses per user"),
        validFrom: zod
          .string()
          .datetime({})
          .optional()
          .describe("Valid from date"),
        validUntil: zod
          .string()
          .datetime({})
          .optional()
          .describe("Valid until date"),
        isActive: zod.boolean().describe("Is Active status"),
        createdAt: zod.string().datetime({}).describe("Created At"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 프로모션 코드 사용 이력 조회
 */
export const adminPromotionControllerGetRedemptionHistoryParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminPromotionControllerGetRedemptionHistoryQueryParams = zod
  .object({
    offset: zod.coerce.number().optional(),
    limit: zod.coerce.number().optional(),
  })
  .strict();

export const adminPromotionControllerGetRedemptionHistoryResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("Redemption ID"),
              promotionCodeId: zod.string().describe("Promotion Code ID"),
              userId: zod.string().describe("User ID"),
              userName: zod.string().optional().describe("User Name"),
              userPhone: zod.string().optional().describe("User Phone"),
              userLoginId: zod.string().optional().describe("User Login ID"),
              redeemedAt: zod.string().datetime({}).describe("Redeemed At"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 프로모션 코드 유효성 검증
 */
export const promotionControllerValidateCodeParams = zod
  .object({
    code: zod.coerce.string().describe("검증할 프로모션 코드"),
  })
  .strict();

export const promotionControllerValidateCodeResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("Promotion ID"),
        code: zod.string().describe("Promotion Code"),
        description: zod.string().optional().describe("Description"),
        targetPlanType: zod
          .enum(["FREE", "PRO", "ENTERPRISE", "TEST"])
          .describe("Target Plan Type"),
        durationDays: zod.number().describe("Duration in days"),
        maxUsesPerCode: zod.number().optional().describe("Max uses total"),
        currentUses: zod.number().describe("Current usage count"),
        maxUsesPerUser: zod.number().describe("Max uses per user"),
        validFrom: zod
          .string()
          .datetime({})
          .optional()
          .describe("Valid from date"),
        validUntil: zod
          .string()
          .datetime({})
          .optional()
          .describe("Valid until date"),
        isActive: zod.boolean().describe("Is Active status"),
        createdAt: zod.string().datetime({}).describe("Created At"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 프로모션 코드를 적용하여 구독 플랜을 변경하거나 만료일을 연장합니다.
 * @summary 프로모션 코드 등록 (구독 연장/업그레이드)
 */
export const promotionControllerRedeemBody = zod
  .object({
    code: zod.string().describe("Promotion Code"),
  })
  .strict();
